/** Подпись роли в шапке staff (техническое значение `me.role` → RU). */
export function staffRoleLabel(role: string | undefined | null): string {
  if (!role) return '—';
  const r = role.trim().toLowerCase();
  const map: Record<string, string> = {
    superadmin: 'Суперадмин',
    platform_staff: 'Сотрудник платформы',
    org_main_admin: 'Администратор организации',
    branch_admin: 'Админ филиала',
    staff: 'Персонал',
    trainer: 'Тренер',
    client: 'Клиент'
  };
  if (r === 'admin') {
    return map.org_main_admin;
  }
  return map[r] ?? role;
}
